import React from 'react'
import "./Academy.css"
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import AcademyHero from '../../components/pages/Academy/AcademyHero/AcademyHero'
import WhyUs from '../../components/pages/Academy/WhyUs/WhyUs'
import Courses from '../../components/pages/Academy/Courses/Courses'
import GetInTouch from '../../components/pages/Academy/GetInTouch/GetInTouch'

const Academy = () => {
    return (
        <div className='academy-page'>
            <Navbar />
            <AcademyHero />

            <div className="academy-page-content-guide">
                <WhyUs />
                <div id="academy-courses">
                <Courses />
                </div>
                <GetInTouch />
            </div>
            <Footer />
        </div>
    )
}

export default Academy